/**
 * Created by Jerker Nord on 2019-09-02.
 */
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {BonusBunniesFreeSpinIntroController} from "./BonusBunniesFreeSpinIntroController";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Button} from "@nolimitcity/slot-game/bin/core/component/Button";
import {BonusBunniesDotNavigation} from "./BonusBunniesDotNavigation";
import {FSIntroPage} from "./FSIntroPage";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

export class BonusBunniesFreeSpinIntroView extends ScreenView {

    private static PAGE_01_TEXT:string = "Fill all positions to get the key to the chest!";
    private static PAGE_02_TEXT:string = "A win resets the spin meter. All wins displayed in times the bet.";
    private static PAGE_03_TEXT:string = "Land bunnies for an extra boost of the wins.";

    protected readonly DEFAULT_MOBILE_SCALE:number = 1;
    protected readonly DEFAULT_PORTRAIT_SCALE:number = 1;

    private _container:PIXI.Container;
    private _blackGfx:PIXI.Graphics;
    private _darkenBackground:PIXI.Graphics;
    private _backgroundImage:PIXI.Sprite;
    private _backgroundFrameImage:PIXI.Sprite;
    private _buttonLeft:PIXI.Sprite;
    private _buttonRight:PIXI.Sprite;
    private _fsIntro0:PIXI.spine.Spine;
    private _currentViewIndex:number = 0;
    private _fsViewsContainer:PIXI.Container;
    private _views:FSIntroPage[];
    private _buttonClickEnabled:boolean = true;
    private _dotNavigationContainer:PIXI.Container;
    private _dotNavigations:BonusBunniesDotNavigation[];
    private _style = new PIXI.TextStyle({
        fill : 0xedc19e,
        fontFamily : "Open Sans",
        wordWrap : true,
        padding : 20,
        wordWrapWidth : 500,
        fontSize : 26,
        breakWords : true
    });

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
    }

    protected initAnimations():void {
        super.initAnimations();

        this._blackGfx = new PIXI.Graphics();
        this._blackGfx.alpha = 0;
        this.addChild(this._blackGfx);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const cont:PIXI.Container = new PIXI.Container();

        this._darkenBackground = new PIXI.Graphics();
        this._darkenBackground.alpha = 0.5;

        cont.addChild(this._darkenBackground);

        this._backgroundImage = new PIXI.Sprite(GameResources.getTextures("FSIntro_BG")[0]);
        this._backgroundImage.position.set(-315, -315);
        cont.addChild(this._backgroundImage);

        this._backgroundFrameImage = new PIXI.Sprite(GameResources.getTextures("mainReelFrame")[0]);
        this._backgroundFrameImage.position.set(-480, -385);
        cont.addChild(this._backgroundFrameImage);

        this._fsIntro0 = new PIXI.spine.Spine(GameResources.getSpineAsset("FSIntro0"));
        this._fsIntro0.position.y = -110;
        this._fsIntro0.alpha = 0;
        cont.addChild(this._fsIntro0);

        this._fsViewsContainer = new PIXI.Container();
        this._fsViewsContainer.position.y = 0;
        this._fsViewsContainer.visible = false;
        cont.addChild(this._fsViewsContainer);

        this._views = [];

        const introPage01:FSIntroPage = new FSIntroPage(new PIXI.spine.Spine(GameResources.getSpineAsset("FSIntro1")), BonusBunniesFreeSpinIntroView.PAGE_01_TEXT, this._style);
        introPage01.alpha = 0;
        this._fsViewsContainer.addChild(introPage01);
        this._views.push(introPage01);

        const introPage02:FSIntroPage = new FSIntroPage(new PIXI.spine.Spine(GameResources.getSpineAsset("FSIntro2")), BonusBunniesFreeSpinIntroView.PAGE_02_TEXT, this._style);
        introPage02.alpha = 0;
        introPage02.animation.position.y -= 30;
        this._fsViewsContainer.addChild(introPage02);
        this._views.push(introPage02);

        const introPage03:FSIntroPage = new FSIntroPage(new PIXI.spine.Spine(GameResources.getSpineAsset("FSIntro3")), BonusBunniesFreeSpinIntroView.PAGE_03_TEXT, this._style);
        introPage03.alpha = 0;
        this._fsViewsContainer.addChild(introPage03);
        this._views.push(introPage03);

        const buttonLeftTexture:PIXI.Texture = GameResources.getTextures("btnL")[0];
        this._buttonLeft = new Button({
            idle : buttonLeftTexture,
            over : buttonLeftTexture,
            down : buttonLeftTexture,
            disabled : buttonLeftTexture
        }, () => this.onButtonLeftClick());
        this._buttonLeft.position.set(-286, 173);
        this._fsViewsContainer.addChild(this._buttonLeft);

        this._dotNavigationContainer = new PIXI.Container();
        this._dotNavigationContainer.alpha = 0;
        this._dotNavigations = [];
        cont.addChild(this._dotNavigationContainer);
        for(let i:number = 0; i < this._views.length; i++) {
            let dotNavigation:BonusBunniesDotNavigation = new BonusBunniesDotNavigation();
            dotNavigation.index = i;
            dotNavigation.position.x = i * (dotNavigation.width + 30);
            this._dotNavigations.push(dotNavigation);
            dotNavigation.interactive = true;
            dotNavigation.buttonMode = true;
            dotNavigation.on('pointertap', () => this.onNavigationDotClick(dotNavigation), this);
            this._dotNavigationContainer.addChild(dotNavigation);
        }
        this._dotNavigationContainer.position.set(0 - (this._dotNavigations.length * (this._dotNavigations[0].width - 10)), 155);
        this._dotNavigations[0].activate();

        const buttonRightTexture:PIXI.Texture = GameResources.getTextures("btnR")[0];
        this._buttonRight = new Button({
            idle : buttonRightTexture,
            over : buttonRightTexture,
            down : buttonRightTexture,
            disabled : buttonRightTexture
        }, () => this.onButtonRightClick());
        this._buttonRight.position.set(286, 173);
        this._fsViewsContainer.addChild(this._buttonRight);

        this._container = cont;

        return this._container;
    }

    protected setButtonPosition(data:IResizeData):void {
        super.setButtonPosition(data);
        this._button.position.y = ((data.height - 720) / 2) + 620;
    }

    private onNavigationDotClick(dot:BonusBunniesDotNavigation):void {
        if(dot.index == this._currentViewIndex) {
            return;
        }
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_INTRO_CLICK);
        this._dotNavigations[this._currentViewIndex].disable();
        this._dotNavigations[dot.index].activate();
        new TweenLite(this._views[this._currentViewIndex], 0.2, {alpha : 0, ease : Linear.easeNone});
        new TweenLite(this._views[dot.index], 0.2, {alpha : 1, ease : Linear.easeNone});
        this._views[dot.index].animation.state.setAnimation(0, "base", false);
        this._currentViewIndex = dot.index;
    }

    private onButtonLeftClick():void {
        if(this._buttonClickEnabled == false) {
            return;
        }
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_INTRO_CLICK);
        this._buttonClickEnabled = false;
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this._buttonLeft.scale.set(0.8, 0.8));
        tl.add([
            new TweenLite(this._views[this._currentViewIndex], 0.2, {alpha : 0, ease : Linear.easeNone}),
            new TweenLite(this._views[this.moveIndexLeft()], 0.2, {alpha : 1, ease : Linear.easeNone}),
            () => this._dotNavigations[this._currentViewIndex].activate(),
            () => this._dotNavigations[this.moveIndexRight()].disable(),
            () => this.moveIndexLeft()

        ]);
        tl.add(() => this._buttonLeft.scale.set(1, 1));
        tl.add(() => this._views[this.getCurrentIndex()].animation.state.setAnimation(0, "base", false));
        tl.add(() => this._buttonClickEnabled = true);
    }

    private getCurrentIndex():number {
        return this._currentViewIndex;
    }

    private moveIndexLeft():number {
        this._currentViewIndex--;
        if(this._currentViewIndex < 0) {
            this._currentViewIndex = this._views.length - 1;
        }
        return this._currentViewIndex;
    }

    private onButtonRightClick():void {
        if(this._buttonClickEnabled == false) {
            return;
        }
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_INTRO_CLICK);
        this._buttonClickEnabled = false;
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this._buttonRight.scale.set(0.8, 0.8));
        tl.add([
            new TweenLite(this._views[this._currentViewIndex], 0.2, {alpha : 0, ease : Linear.easeNone}),
            new TweenLite(this._views[this.moveIndexRight()], 0.2, {alpha : 1, ease : Linear.easeNone}),
            () => this._dotNavigations[this._currentViewIndex].activate(),
            () => this._dotNavigations[this.moveIndexLeft()].disable(),
            () => this.moveIndexRight()
        ]);
        tl.add(() => this._buttonRight.scale.set(1, 1));
        tl.add(() => this._views[this.getCurrentIndex()].animation.state.setAnimation(0, "base", false));
        tl.add(() => this._buttonClickEnabled = true);
    }

    private moveIndexRight():number {
        this._currentViewIndex++;
        if(this._currentViewIndex > this._views.length - 1) {
            this._currentViewIndex = 0;
        }
        return this._currentViewIndex;
    }

    private resetFSViews():void {
        this._fsViewsContainer.visible = false;
        this._currentViewIndex = 0;
        for(let i:number = 0; i < this._views.length; i++) {
            this._views[i].alpha = 0;
        }
        for(let i:number = 0; i < this._dotNavigations.length; i++) {
            this._dotNavigations[i].disable();
        }
        this._dotNavigations[0].activate();
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);
        this.position.x = 0 - (Math.ceil(resizeData.width / this._layer.scale.x) - 720) / 2;
        this.position.y = 0 - (Math.ceil(resizeData.height / this._layer.scale.y) - 720) / 2;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        this._blackGfx.clear();
        this._blackGfx.beginFill(0x000000);
        this._blackGfx.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._blackGfx.endFill();

        this._darkenBackground.clear();
        this._darkenBackground.beginFill(0x000000);
        this._darkenBackground.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._darkenBackground.endFill();
        this._darkenBackground.position.set(-this._darkenBackground.width * 0.5, -this._darkenBackground.height * 0.5);
    }

    protected startPresentation(data:ParsedServerData, onShowComplete?:() => void):void {
        this._container.alpha = 0;
        this._button.alpha = 0;
        this._dotNavigationContainer.alpha = 0;
        this.resetFSViews();
        if(this._autoCloseTimer) {
            this._autoCloseTimer.alpha = 0;
        }

        this.alpha = 1;

        const tl:TimelineLite = new TimelineLite();
        tl.add([
            this.fadeInBlack(),
            () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_INTRO)
        ]);
        tl.add(() => BonusBunniesFreeSpinIntroController.actuallyDoTransition());
        tl.add(() => {
            this._container.alpha = 1;
            this._button.alpha = 1;
        });
        tl.add(this.fadeOutBlack());
        tl.add(() => {
            super.startPresentation(data, onShowComplete);
            if(this._autoCloseTimer) {
                this._autoCloseTimer.alpha = 1;
            }
        });
        tl.add(() => this._fsIntro0.alpha = 1);
        tl.add(() => this._fsIntro0.state.setAnimation(0, "base", false));
        tl.add(() => this._fsIntro0.alpha = 0, "+=2");
        tl.add(() => this._fsViewsContainer.visible = true);
        tl.add([
            new TweenLite(this._views[0], 0.4, {alpha : 1, ease : Linear.easeNone}),
            new TweenLite(this._dotNavigationContainer, 0.4, {alpha : 1, ease : Linear.easeNone})
        ]);
    }


    protected stopPresentation(closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(new TweenLite(this, 0.6, {alpha : 0, ease : Linear.easeNone}));
        timeline.add(() => this.resetFSViews());
        timeline.add(() => super.stopPresentation(closeCallback));

    }

    private fadeInBlack():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._blackGfx, 0.6, {alpha : 1, ease : Linear.easeNone}));
        return tl;
    }

    private fadeOutBlack():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._blackGfx, 0.6, {alpha : 0, ease : Linear.easeNone}));
        return tl;
    }
}
